import { useLocalStorage } from "@jugl-web/utils/hooks/useStorage";
import { ENTITY_ID_KEY } from "@jugl-web/utils/storage";
import { useFeaturesShowcaseModal } from "@web-src/modules/entities/components/FeaturesShowcaseModal/useFeaturesShowcaseModal";
import { useNavigation } from "@web-src/modules/navigation/hooks/useNavigation";

export const useNavigateToEntityById = () => {
  const [, setEntityId] = useLocalStorage(ENTITY_ID_KEY, "");
  const { navigateToPage } = useNavigation();
  const { open: openFeaturesShowcaseModal } = useFeaturesShowcaseModal();
  return (entityId: string, showShowcase?: boolean) => {
    setEntityId(entityId);
    navigateToPage("entityEntryPoint", { targetEntityId: entityId });
    if (showShowcase) {
      openFeaturesShowcaseModal(true);
    }
  };
};
